import React from 'react';
import LinksRow from './LinksRow';


function LinksTable({websx = []}) {
      if (!websx) {
            console.log("websx is undefined");
            return <div>Loading...</div>;
            }

    console.log("websx:", websx);
            
    return (
           
        <table id="web-links">
            <caption className='caption_text'>Web Links Table </caption>   
            <thead>
                <tr>
                    <th className='type_box'>Description</th>
                    <th className='link_box'>Web Links</th>
                </tr>
            </thead>
            <tbody>
                {websx.map((wx, i) => (
                     <LinksRow websx={wx} key={i} />
                    ))}
            </tbody>
        </table>
    );
}
export default LinksTable;